import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var EyeOpened = function EyeOpened(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8c0-1.5-3.582-5-8-5S0 6.5 0 8s3.582 5 8 5 8-3.5 8-5zm-2.08 0a2.97 2.97 0 00-.148-.213c-.27-.36-.708-.804-1.299-1.237a8.421 8.421 0 00-1.023-.643 3.5 3.5 0 11-6.9 0 8.418 8.418 0 00-1.024.643c-.59.433-1.028.877-1.298 1.237A2.931 2.931 0 002.08 8c.035.057.083.128.147.213.27.36.708.804 1.298 1.237C4.716 10.323 6.311 11 8 11c1.69 0 3.284-.677 4.473-1.55.59-.433 1.029-.877 1.3-1.237A2.97 2.97 0 0013.918 8zM7.5 7.5a1 1 0 100-2 1 1 0 000 2z",
    fill: "currentColor"
  }));
};
export default EyeOpened;